module.exports = __webpack_public_path__ + "img/circle4.40a59d4f.png";